/** The words of the tenant lifecycle surfaces (tenant retirement) — one place, so the operator
 *  page's banner, its Lifecycle tab, the tour operators grid and the tenant picker say the same
 *  thing. */
import type { TenantLifecycle, TenantLifecycleRequestKind } from '@/api/tenantLifecycle';

export const LIFECYCLE_LABEL: Record<TenantLifecycle, string> = {
  active: 'Active',
  closed: 'Closed',
  releasing: 'Releasing code',
  released: 'Code released',
  restoring: 'Restoring',
};

/** Not `active`: refused on every surface (a licensee of a closed franchise parent is refused too,
 *  whatever its own value — the list and the picker only know the own value). */
export function isClosedLifecycle(lifecycle: TenantLifecycle | null | undefined): boolean {
  return lifecycle != null && lifecycle !== 'active';
}

/** The request button / dialog title per kind. */
export const LIFECYCLE_ACTION_LABEL: Record<TenantLifecycleRequestKind, string> = {
  close: 'Close',
  release: 'Release the code',
  reopen: 'Reopen',
};

/** What each lifecycle means, for the state row. */
export const LIFECYCLE_HELP: Record<TenantLifecycle, string> = {
  active: 'The tenant runs normally.',
  closed:
    'Every surface refuses the tenant: its users and API keys, its webhooks, sends and tasks. Its data stays; reopening makes it active again.',
  releasing: 'A job is giving up the tenant’s code, so another tenant may take it.',
  released: 'The tenant’s code was given up; it keeps a placeholder code from then on.',
  restoring: 'A job is giving the tenant its code back.',
};
